import { useEffect, useRef } from 'react';

import { useEditorInlineCommentsPubSub as usePubsub } from '@confluence/comments-pubsub/entry-points/inlineComments.ts';
type PubSubProps = {
	contentId: string;
	contentType: string;
	triggerAnalyticsEvent: (
		eventName: string,
		extraData?: {
			[key: string]: any;
		},
	) => Promise<void>;
	updateUnresolvedInlineComment: (unresolvedInlineComments: string[]) => void;
	isEnabled?: boolean;
	isDocumentActive?: boolean;
	addCommentInCache?: ({
		newComment,
		onError,
	}: {
		newComment: any;
		onError?: (error: Error) => void;
	}) => void;
	deleteCommentInCache?: ({
		commentId,
		onError,
	}: {
		commentId: string;
		onError?: (error: Error) => void;
	}) => void;
};

export const useEditorInlineCommentsPubSub = ({
	contentId,
	contentType,
	triggerAnalyticsEvent,
	updateUnresolvedInlineComment,
	isEnabled = true,
	isDocumentActive,
	addCommentInCache,
	deleteCommentInCache,
}: PubSubProps): {
	reloadMissedComments: () => Promise<void>;
} => {
	const isRegistered = useRef(false);

	const { register, unregister, reloadMissedComments } = usePubsub({
		contentId,
		triggerAnalyticsEvent,
		updateUnresolvedInlineComment,
		contentType,
		addCommentInCache,
		deleteCommentInCache,
	});

	useEffect(() => {
		if (isEnabled && !isRegistered.current) {
			register();
			isRegistered.current = true;

			return () => {
				unregister();
				isRegistered.current = false;
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEnabled, register, unregister, isDocumentActive]);

	return { reloadMissedComments };
};
